import { render, staticRenderFns } from "./done.vue?vue&type=template&id=22bd8869&"
import script from "./done.vue?vue&type=script&lang=js&"
export * from "./done.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports